<template>
  <main class="main customer_keyword_stores" role="main">
    <div class="main_con">
      <div class="con_ttl top10">
        {{ benefit.name }}
      </div>
      <div class="" v-if="fetchCompleted">
        <div class="store_list_wrap">
          <Shop2
            v-for="(store, i) in stores.content"
            :key="i"
            :store="store"
            @toggle="toggleFollow(store, store.id)"
          />
        </div>
      </div>
      <div class="store_list_wrap" v-else>
        <SkeletonStoreItem v-for="index in 6" :key="index" />
      </div>
    </div>
    <DesignPopup
      @close="confirm"
      :show="designPopup"
      :data="popupParams"
    ></DesignPopup>
  </main>
</template>

<script>
import Shop2 from '../shops/components/Shop2.vue';
import { mapActions, mapGetters } from '@common/store/modules/keyword';
import * as keywordTypes from '@common/store/modules/keyword/types';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import {
  mapActions as shopMapActions,
  mapState as shopMapStates,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';

import DesignPopup from '@/common/components/modal/DesignPopup.vue';
import SkeletonStoreItem from '@common/components/shop/SkeletonItem/StoreItem.vue';

export default {
  components: { Shop2, DesignPopup, SkeletonStoreItem },
  async beforeRouteEnter(to, from, next) {
    return await next(async vm => {
      await vm.fetch();
    });
  },
  data() {
    return {
      designPopup: false,
      popupParams: {
        type: 'confirm',
        msg: '',
      },
      fetchCompleted: false,
    };
  },
  computed: {
    ...mapGetters({
      section: keywordTypes.SECTION,
      benefit: keywordTypes.BENEFIT,
      stores: keywordTypes.STORES,
    }),
    ...userMapGetters({
      userInfo: userTypes.USER,
    }),
  },
  methods: {
    ...mapActions([keywordTypes.FETCH_STORES]),
    ...shopMapActions([shopTypes.SHOP_UNFOLLOW, shopTypes.SHOP_FOLLOW]),
    async fetch() {
      console.log('aaaa');
      console.log(this.stores);
      console.log('bbbb');
      // this.$route.meta.header.title = this.$route.query.title;
      const param = {
        emdAreaId: this.userInfo.emdAreaId,
        userId: this.userInfo.id,
        keywordBenefitId: this.benefit.keywordBenefitId || this.benefit.id,
        keywordId: this.section.id,
        isLoading: false,
      };
      await this[keywordTypes.FETCH_STORES](param);
      this.fetchCompleted = true;
    },
    toggleFollow(shop, id) {
      const params = { id: id };
      if (shop.followed != false) {
        this.popupParams.msg = '';
        this[shopTypes.SHOP_UNFOLLOW](params);
      } else {
        this[shopTypes.SHOP_FOLLOW](params);
      }
      this[shopTypes.FETCH_SHOP](params);
    },
    confirm() {},
  },
};
</script>
